<template>
  <v-layout wrap v-if="appliedFilters && appliedFilters.length > 0" class="filter-pills-list">
    <v-flex v-for="(filter, index) in appliedFilters"
            :key="index"
            @click="removePill(filter)"
            class="filter-pill" mb-2>
      <span class="filter-pill__name" :data-qe-id="`ypo-events-filter-pill_${index}_label`">
            {{filterPillLabel(filter)}}
      </span>
      <span class="filter-pill__close">
            <v-icon color="black" size="15"
                    :data-qe-id="`ypo-events-filter-pill_${index}_remove_btn`">
              close
            </v-icon>
        </span>
    </v-flex>
    <v-flex class="filter-pills-list__clear-all pointer"
            @click="handleClear"
            data-qe-id="ypo-events_clear-all-filters_btn">
      <span class="filter-pills-list__clear-all-label">{{ypoEventConstant.label.CLEAR_ALL}}</span>
    </v-flex>
  </v-layout>
</template>
<script>
import { ypoEventConstant } from "@/components/YpoEvents/ypoEvents.constant";

export default {
  name: 'YpoEventsAppliedFilterPills',
  data() {
    return {
      ypoEventConstant,
    };
  },
  props: {
    appliedFilters: {
      type: Array,
      required: true,
      default: () => [],
    },
    totalAppliedFiltersCount: {
      type: Number,
      required: true,
      default: 0,
    },
    handleClose: {
      type: Function,
      required: true,
      default: () => {},
    },
    handleClear: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  methods: {
    removePill(filterPill) {
      const { totalAppliedFiltersCount } = this;
      if (totalAppliedFiltersCount && totalAppliedFiltersCount > 1) {
        this.handleClose(filterPill);
      } else {
        this.handleClear();
      }
    },
    filterPillLabel(filter) {
      if (filter) {
        if (filter.filterKey === ypoEventConstant.constant.keys.countryState) {
          const dividerIndex = filter.filterValue.indexOf('>');
          if (dividerIndex > 0) {
            return `${filter.filterValue.substring(0, dividerIndex)}, ${filter.label}`;
          }
        } else if (filter.filterKey === ypoEventConstant.constant.keys.countryStateCity && filter.pillDisplayLabel) {
          return filter.pillDisplayLabel;
        }
      }
      return filter.label;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.filter-pills-list {
  padding: 24px 0 15px 5px;
  @include breakpointMin(lg) {
    max-width: 60%;
  }
    
  &__item {
    margin-right: 10px;
    margin-bottom: 15px;
  }

  &__clear-all {
    background-color: $white;
    flex: 0 1 auto !important;
    padding: 10px;
    text-transform: uppercase;
    color: $ypo-cod-gray;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 17px;

    &-label {
      text-decoration: underline;
    }
  }

  .filter-pill {
    border: 1px solid $ypo-cobalt-bluish-gray;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    border-radius: 18px;
    background-color: $white;
    flex: 0 1 auto !important;
    padding: 5px 13px 8px 15px;
    box-shadow: 0 0 5px 0 rgba($black, 0.12);
    margin-right: 12px;
    text-transform: capitalize!important;

    &:hover {
      cursor: pointer;
      border-color: $ypo-gray;
      box-shadow: 0 0 5px 0 rgba($black, 0.36);
      transition-property: all;
      transition-duration: 200ms;  
      .filter-pill__name{
        text-decoration: underline;
      }
    }

    &__close {
      color: $ypo-cod-gray;
      position: relative;
      margin-top: -2px;
    }

    &__name {
      padding-right: 5px;
      font-size: 12px;
      color: $ypo-border-gray;
      font-family: "Noto Sans";
      letter-spacing: 0;
      line-height: 17px;
    }
  }
}

</style>
